const React = require('react');

const formatNumFiat = require('../../../../../../utils/formatNumFiat');
const formatNumCoin = require('../../../../../../utils/formatNumCoin');
const getExplorerUrlPrefixByCoin = require('../../../../../../utils/getExplorerUrlPrefixByCoin');
const formatCCSymbol = require('../../../../../../utils/formatCCSymbol');


const RowA = require('../../../../../dumb/Row/A');
const ColA = require('../../../../../dumb/Col/A');
const ColA2 = require('../../../../../dumb/Col/A2');
const Tooltip = require('../../../../../dumb/Tooltip/A');
const {AdminTimeCell} = require('../../../../../dumb/TableTimeCell');
const {TableNumberColAmin} = require('../../../../../dumb/TableNumberCol/');
const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayDateTimeAdmin,
  DisplayAmountAdmin,
  DisplayHashAdmin
} = require('../../../../../dumb/DisplayData/');

const MposIcon = require('./svg/MposIcon');
const WidgetIcon = require('./svg/WidgetIcon');


module.exports = ({data}) => {
  const {
    id,
    value_fiat: fiatValue,
    value_cc: ccValue,
    spread_final: spreadFinal,
    fee,
    hash,
    coin,
    client_kind: paymentType
  } = data;
  const time = data.time || '';
  const ccSymbol = formatCCSymbol(coin);
  const eurValue = data.fiat === 'EUR' && !data.value_eur ? fiatValue : data.value_eur;

  return (
    <RowA className="f12">
      <ColA2 className="wmin40">
        {paymentType === 'Device'
          ? (
            <Tooltip title="MPOS" disabledCopy>
              <MposIcon width="30px" />
            </Tooltip>
          ) : (
            <Tooltip title="Widget" disabledCopy>
              <WidgetIcon width="30px" />
            </Tooltip>
          )
        }
      </ColA2>
      <ColA className="wmin155 fx1">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </ColA>
      <ColA className="wmin95">
        <DisplayDateTimeAdmin date={time}/>
      </ColA>
      <ColA className="wmin200 fx1">
        <DisplayHashAdmin
          symbol={coin}
          hash={hash}
        />
      </ColA>
      <ColA className="wmin100 fx1">
        <DisplayAmountAdmin
          amount={fee}
          symbol={data.fiat}
          type="fiat"
        />
      </ColA>
      <ColA className="wmin100 fx1">
        <Tooltip>
          {spreadFinal}
        </Tooltip>
      </ColA>
      <ColA className="wmin175 fx1">
        <DisplayAmountAdmin
          amount={ccValue}
          symbol={ccSymbol}
          type="coin"
        />
      </ColA>
      {/*<ColA className="wmin125 fx1">*/}
      {/*  {formatCCSymbol(coin)}*/}
      {/*</ColA>*/}
      <ColA className="wmin125 fx1">
        <DisplayAmountAdmin
          amount={fiatValue}
          symbol={data.fiat}
          type="fiat"
        />
      </ColA>
      {/*<ColA className="wmin100 fx1">{data.fiat}</ColA>*/}
      <ColA className="wmin125 fx1">
        <DisplayAmountAdmin
          amount={eurValue}
          symbol="EUR"
          type="fiat"
        />
      </ColA>
      <ColA className="wmin150 fx1">
        <DisplayDataAdmin>{data.company_name}</DisplayDataAdmin>
      </ColA>
      <ColA className="wmin150 fx1">
        <DisplayDataAdmin>{data.username}</DisplayDataAdmin>
      </ColA>
    </RowA>
  );
};
